/**
 * This directive catches a dynamic list of events from the component it is on
 * and emits them from the component it is in
 * Example:
 * <CurrentComponent>
 *     <DynamicComponent v-dynamic-events="['event1', 'event2']">
 * </>
 * In the above example, when DynamicComponent fires event1 and event2,
 * CurrentComponent will then bubble the events up
 */
export default {
    bind(el, binding, vnode) {
        const allEvents = binding.value;
        if (allEvents) {
            allEvents.forEach((event) => {
                // register handler in the dynamic component
                vnode.componentInstance.$on(event, (eventData) => {
                    // when the event is fired, the proxyEvent function is going to be called
                    vnode.context.$emit(event, eventData);
                });
            });
        }
    },
    unbind(el, binding, vnode) {
        vnode.componentInstance.$off();
    }
};
